/**
 * Orders a parent/child group for display: the parent (the order whose
 * order_id equals the group root) is always first, followed by the remaining
 * orders sorted alphabetically by order_number.
 *
 * Returns [] for an empty/missing list so callers can render nothing without
 * special-casing. If the parent row is absent (e.g. an orphaned child whose
 * original order was deleted), falls back to a flat alphabetical list.
 *
 * @param {Array<{ order_id: string, order_number: string }>} orders
 * @param {string} rootId - original_order_id ?? order_id of the current order
 * @returns {Array} parent-first, then alphabetical
 */
export const orderLinkedOrders = (orders, rootId) => {
    if (!orders?.length) return [];

    const parent = orders.find((o) => o.order_id === rootId) ?? null;
    const rest = orders
        .filter((o) => o !== parent)
        .sort((a, b) => (a.order_number ?? '').localeCompare(b.order_number ?? ''));

    return parent ? [parent, ...rest] : rest;
};
